/* eslint-disable func-names */
const ScrollListener = (function () {
  let observer = null;
  return {
    start: (targetElement, callback = () => {}) => {
      setTimeout(() => {
        const domTargetElement = document.querySelector(targetElement);
        if (observer) {
          observer.disconnect();
          observer = null;
        }

        if (!domTargetElement) {
          return;
        }
        const options = {
          root: null,
          rootMargin: '0px',
          threshold: 1.0,
        };

        observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (!entry) {
            return;
          }
          if (entry.isIntersecting) {
            const elem = entry.target;
            if (entry.intersectionRatio >= 0.75) {
              observer.unobserve(elem);
              callback();
            }
          }
        }, options);

        observer.observe(domTargetElement);
      }, 1000);
    },
    stop: () => {
      if (observer) {
        observer.disconnect();
      }
    },
  };
})();
export default ScrollListener;
